import React from "react";
import Button from "common-ui-components/components/button";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Error caught in ErrorBoundary:");
    console.error("Error:", error);
    console.error("Error Info:", errorInfo);

    const isChunkError =
      error?.name === "ChunkLoadError" ||
      error?.message?.includes("Loading chunk") ||
      error?.message?.includes("Failed to fetch dynamically imported module");

    if (isChunkError) {
      const hasRefreshed = sessionStorage.getItem("chunk-reload");

      if (!hasRefreshed) {
        sessionStorage.setItem("chunk-reload", "true");
        window.location.reload();
        return;
      }

      // If we've already refreshed once, clear the flag
      sessionStorage.removeItem("chunk-reload");
    }
  }

  handleGoHome = () => {
    sessionStorage.removeItem("chunk-reload");
    window.location.href = "/";
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            gap: "1rem",
          }}
        >
          <h2>Something went wrong.</h2>

          <Button variant="primary" onClick={this.handleGoHome}>
            Go to Home
          </Button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;